<template>
    <div>
        <hd-header></hd-header>
        <div style="display: flex;justify-content: center;align-items: center;margin-bottom: 60px;margin-top: 200px;">
            <el-card style="width: 1200px;">
                <p style="text-align: center;margin-top: 80px;">
                    <i class="el-icon-success" style="font-size: 80px;color: #5cb138;"></i>
                </p>
                <p style="font-size: 16px;color: #666666;margin-top: 50px;text-align: center;">认证完成，请等待审核</p>
                <p style="font-size: 14px;text-align: center;color: #999999;margin-top: 80px;margin-bottom: 80px;">
                    审核结果可以在用户中心查看，{{timeLimit}}s后自动 <span style="color: #00a4e0;cursor: pointer;"
                        @click="toLogin()">返回网站首页</span>
                </p>
            </el-card>
        </div>
        <hd-footer></hd-footer>
    </div>
</template>

<script>
    import HdHeader from '../public/Header.vue'
    import HdFooter from '../public/FooterLogined.vue'

    export default {
        name: 'realnameSuccess',
        components: {
            HdHeader,
            HdFooter
        },
        created() {
            let that = this;
            setTimeout(function() {
                that.timeDec();
            }, 1000);
        },
        data: function() {
            return {
                timeLimit: 5
            };
        },
        methods: {
            toLogin: function() {
                this.$router.push({
                    path: '/'
                });
            },
            timeDec: function() {
                if (this.timeLimit > 0) {
                    this.timeLimit--;
                }
                if (this.timeLimit == 0) {
                    //跳转
                    this.toLogin();
                } else {
                    let that = this;
                    setTimeout(function() {
                        that.timeDec();
                    }, 1000);
                }
            }
        }
    }
</script>

<style>
    body {
        background-color: #F8F8F8;
    }
</style>



// WEBPACK FOOTER //
// src/components/register/RealnameSuccess.vue